import React from 'react';
import { Link } from 'react-router-dom';
import '../../components/InfoPages.css';

const PrivacyPolicy = () => {
    return (
        <div className="info-page-container">
            <header className="info-page-header">
                <Link to="/" className="back-link">← Back to Home</Link>
                <h1>Privacy Policy for Ernify</h1>
            </header>

            <main className="info-page-content">
                    <p><em>Last updated: October 26, 2025</em></p>

                <section>
                    <h2>Information We Collect</h2>
                    <p>
                        We collect non-personal device information (such as device type and operating-system version) to ensure compatibility and improve our service. To process payments and prevent fraud, we collect your <strong>payment account identifier</strong> and basic profile information such as a unique user ID. We <strong>do not</strong> collect sensitive financial data directly.
                    </p>
                </section>

                <section>
                    <h2>How We Use Your Information</h2>
                    <p>
                        The information we collect is used solely to:
                    </p>
                    <ul>
                        <li>Operate and maintain the Ernify app.</li>
                        <li>Process and fulfill your earnings payouts.</li>
                        <li>Monitor and analyze usage to improve app functionality and user experience.</li>
                        <li>Detect, prevent, and address technical issues and fraudulent activity.</li>
                    </ul>
                </section>

                <section>
                    <h2>Third-Party Advertising</h2>
                    <p>
                        The advertisements you view are served by third-party ad networks (e.g., Google AdMob). These networks may use tracking technologies to measure the effectiveness of their ads and provide more relevant advertisements. We have limited control over their tracking practices.
                    </p>
                </section>
            </main>

            <footer className="info-page-footer">
                <p>For any questions about this policy, please visit our <Link to="/contact-us">Contact Us</Link> page.</p>
            </footer>
        </div>
    );
};

export default PrivacyPolicy;
